exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#scheduleModal .v--modal-box.v--modal{min-height:400px!important;min-width:450px!important}#btn__bookmark--add{margin-right:0}.btn__bookmark{height:15px;width:15px;background-color:rgba(0,0,0,.54)!important;transition:.2s}.btn__bookmark:hover{background-color:#3f67a4!important}.btn__bookmark__icon{font-size:15px}.group.card__navbar{height:75px}.btn__bookmark__wrapper{display:flex}#start{max-height:84px}#start .v-select__selection,#start .v-select__selection input,#start div.v-select__slot>label{font-size:12px}#start .v-select__slot{max-width:250px}::-moz-input-placeholder,::-webkit-input-placeholder{font-size:14px}#start>div>div:nth-child(3)>div>div:first-child{padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-108343c6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/start/Start.vue
// module id = 1522
// module chunks = 0